<template>
    <div class="relative inline-block">
        <button @click="openModal" class="info-button" title="Description">
            <img :src="require('@/images/dashboard/info-blue.png')" alt="Info">
        </button>
        <div v-if="showModal" ref="modalOverlay" class="modal-overlay" @click="closeModal">
            <div class="modal-content" @click.stop>
                <button class="close-button" @click="closeModal">✖</button>
                <div class="modal-body" v-html="description"></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        description: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            showModal: false
        };
    },
    methods: {
        openModal() {
            this.showModal = true;
            document.body.style.overflow = "hidden";
            this.$nextTick(() => {
                if (this.$refs.modalOverlay && this.$refs.modalOverlay.parentNode !== document.body) {
                    document.body.appendChild(this.$refs.modalOverlay);
                }
            });
        },
        closeModal() {
            if (this.$refs.modalOverlay && this.$refs.modalOverlay.parentNode === document.body) {
                document.body.removeChild(this.$refs.modalOverlay);
            }
            this.showModal = false;
            document.body.style.overflow = "";
        }
    },
    beforeDestroy() {
        if (this.$refs.modalOverlay && this.$refs.modalOverlay.parentNode === document.body) {
            document.body.removeChild(this.$refs.modalOverlay);
        }
    }
};
</script>

<style scoped>
.info-button {
    background: none;
    border: none;
    cursor: pointer;
}

.info-button img {
    width: 24px;
    height: 24px;
}

.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99999;
}

.modal-content {
    background: white;
    padding: 25px;
    border-radius: 8px;
    width: 90%;
    max-width: 900px;
    max-height: 80vh;
    min-height: 100px;
    display: flex;
    flex-direction: column;
    position: relative;
    z-index: 100000;
}

.close-button {
    position: absolute;
    top: 8px;
    right: 12px;
    background: none;
    border: none;
    font-size: 1.4rem;
    cursor: pointer;
    color: #333;
}

.modal-body {
    flex-grow: 1;
    font-family: TTNormsMedium, sans-serif;
    overflow-y: auto;
    max-height: calc(80vh - 40px);
    text-align: center;
    color: #333;
    padding: 10px;
}
</style>